import React, { useState } from 'react';
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Box,
} from '@mui/material';
import inputTypes from '../inputTypes';
import styles from './styles';

const values = [
  {
    value: 'typePhone',
    label: 'Телефон',
  },
  {
    value: 'typeWhatsapp',
    label: 'Whatsapp',
  },
  {
    value: 'typeTelegram',
    label: 'Telegram',
  },
];
const optionalFields = [
  {
    anchors: ['typePhone', 'typeWhatsapp'],
    id: 'phone',
    type: 'phone',
    name: 'phone',
  },
  {
    anchors: ['typeTelegram'],
    id: 'telegram',
    type: 'telegram',
    label: 'Ваш @username в Telegram',
    name: 'telegram',
    rules: {
      required: 'Введите ваш @username в Telegram',
    },
  },
];

function ContactsBlock({
  formFunctions,
  title,
  name,
  defaultValue = values[0].value,
}) {
  const [currentValue, setCurrentValue] = useState(defaultValue);

  const generateField = (item) => {
    const { type, name, rules } = item;
    const { errors, register } = formFunctions;

    const {
      type: fieldType,
      component,
      attributes,
      validation,
    } = inputTypes[type];

    const FieldComponent = component;
    const currentRules = {
      ...rules,
      ...validation,
    };

    let currentAttributes = { ...attributes };
    if (type === 'phone') {
      currentAttributes = { ...attributes, formFunctions };
    }

    const currentValidation = register(name, currentRules);

    return (
      <FieldComponent
        {...item}
        type={fieldType || type}
        error={!!errors[name]}
        helperText={errors[name] && errors[name].message}
        {...currentAttributes}
        {...currentValidation}
      />
    );
  };

  return (
    <>
      <FormControl sx={styles.formControl}>
        {title && (
          <Box variant="desktopP3" sx={styles.title}>
            {title}
          </Box>
        )}
        <RadioGroup
          defaultValue={defaultValue}
          name={name}
          sx={styles.formGroup}
        >
          {values.map((item) => (
            <FormControlLabel
              {...formFunctions.register(name)}
              key={item.value}
              value={item.value}
              name={name}
              control={<Radio />}
              label={item.label}
              onChange={() => setCurrentValue(item.value)}
            />
          ))}
        </RadioGroup>
      </FormControl>

      <FormControl sx={styles.formControl}>
        {optionalFields.map((item) => (
          <Box key={item.name}>
            {item.anchors.includes(currentValue) && generateField(item)}
          </Box>
        ))}
      </FormControl>
    </>
  );
}
export default ContactsBlock;
